<label class="label">{{label}}</label>
<p class="value" *ngIf="translationKey">{{ (translationKey+"."+value) | translate }}</p>
<p class="value" *ngIf="!translationKey">{{value}}</p>
